// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-close-icon[data-v-486161ee] {\n  right: 13px;\n  top: 13px;\n  position: absolute;\n}\n.header-close-icon-mobile[data-v-486161ee] {\n  right: 10px;\n  top: auto;\n  bottom: auto;\n  position: absolute;\n}", ""]);
// Exports
module.exports = exports;
